import React from "react";
import { Card, Text, Badge, makeStyles, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
  card: {
    marginTop: "8px",
    padding: "12px",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "8px",
    marginBottom: "4px",
  },
  oppName: {
    flex: "1 1 0",
    minWidth: 0,
  },
  badge: {
    flexShrink: 0,
  },
  detail: {
    color: tokens.colorNeutralForeground2,
  },
  empty: {
    marginTop: "12px",
    color: tokens.colorNeutralForeground3,
  },
});

interface OpportunityListProps {
  opportunities: any[];
}

export const OpportunityList: React.FC<OpportunityListProps> = ({ opportunities }) => {
  const styles = useStyles();

  if (opportunities.length === 0) {
    return <Text className={styles.empty}>No opportunities found.</Text>;
  }

  return (
    <div>
      {opportunities.map((opp) => (
        <Card key={opp.opportunityid} className={styles.card}>
          <div className={styles.row}>
            <Text weight="semibold" size={300} className={styles.oppName}>{opp.name}</Text>
            <Badge appearance="outline" size="small" className={styles.badge}>
              {opp["statuscode@OData.Community.Display.V1.FormattedValue"] || "Open"}
            </Badge>
          </div>
          {opp.estimatedvalue != null && (
            <Text size={200} className={styles.detail}>
              ${Number(opp.estimatedvalue).toLocaleString()}
            </Text>
          )}
          {opp.estimatedclosedate && (
            <Text size={200} className={styles.detail}>
              Close: {new Date(opp.estimatedclosedate).toLocaleDateString()}
            </Text>
          )}
        </Card>
      ))}
    </div>
  );
};
